import raiseNotification from "../../utils/raiseNotification";
import dispatchAddNewsletter from "../../transport/newsletter";

function subscriptionSuccess(data) {
    raiseNotification(data.message, "success");
}

function subscriptionFailed({ error }) {
    raiseNotification(error, "error");
}

function getSuscriptionFormFields(postID) {
    const postInfo = document.querySelector(`span[data-elid="${postID}"]`);
    const { headline } = postInfo.dataset;
    return {
        subscription_source: "polls",
        subscription_source_name: headline,
    };
}

export function subscribe_email(listicle, context, formElement) {
    const email = formElement.value;
    if (!email) {
        return;
    }
    const postID = listicle.dataset.postId;
    const siteId = context.settings.site.id;
    const fields = getSuscriptionFormFields(postID);

    dispatchAddNewsletter(siteId, email, fields)
        .then(subscriptionSuccess)
        .catch(subscriptionFailed);
}
